import {
  EVENT_SCORE_STATUSES as SharedEventScoreStatuses,
  EVENT_SCORE_RESULTS as SharedEventScoreResults,
  EVENT_SCORE_ENTRY_MODES as SharedEventScoreEntryModes,
} from "shared/dist/types/EventScore";

export type {
  EventScore,
  EventScoreStatus,
  EventScoreResult,
  EventScoreEntryMode,
} from "shared/dist/types/EventScore";

export const EVENT_SCORE_STATUSES = SharedEventScoreStatuses;
export const EVENT_SCORE_RESULTS = SharedEventScoreResults;
export const EVENT_SCORE_ENTRY_MODES = SharedEventScoreEntryModes;
